"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var constants_1 = require("./constants");
function findExperiment(user, name) {
    var experiments = user.experiments || [];
    return lodash_1.find(experiments, { name: name });
}
function isExperimentEnabled(user, name) {
    var experiment = findExperiment(user, name);
    return !!(experiment && experiment.value === 'experiment');
}
exports.isExperimentEnabled = isExperimentEnabled;
function experimentBucket(user, name) {
    var experiment = findExperiment(user, name);
    return experiment && experiment.value;
}
exports.experimentBucket = experimentBucket;
function inMobileApp(user) {
    var device = user && user.deviceName;
    return device === constants_1.IOS || device === constants_1.ANDROID || device === constants_1.LP_NATIVE;
}
exports.inMobileApp = inMobileApp;
//# sourceMappingURL=user_context_helpers.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/user_context_helpers.js
// module id = 9D05
// module chunks = 20 21 22